/**
 * 一对一通话事件动作编码
 *
 * 取值经后端确认。编码变更只改本文件，业务代码只引用常量。
 */
const LIVEKIT_ACTION = {
	CALL: '900', // 收到呼叫
	ACCEPT: '902', // 对方已接听
	REJECT: '903', // 对方拒绝
	BUSY: '904', // 对方正忙
	HANGUP: '905', // 对方挂断
	CANCEL: '906', // 对方取消呼叫
	RING: '932' // 对方已响铃
}

const ACTION_SET = Object.keys(LIVEKIT_ACTION).map((key) => LIVEKIT_ACTION[key])

/**
 * 是否为本模块可处理的通话事件
 */
function isCallEvent(action) {
	return ACTION_SET.indexOf(String(action)) >= 0
}

/**
 * 解析事件负载：{ type: 'audio'|'video', roomTag }
 * 负载缺失时返回空对象，由调用方决定降级行为
 */
function parseEventContent(content) {
	if (!content) {
		return {}
	}
	if (typeof content === 'object') {
		return content
	}
	try {
		return JSON.parse(content)
	} catch (e) {
		return {}
	}
}

export { LIVEKIT_ACTION, isCallEvent, parseEventContent }

export default LIVEKIT_ACTION
